export const MunicipalityInfoActionTypes = {
  SET_MUNICIPALITY_DATA: "SET_MUNICIPALITY_DATA",
  SET_NOTICE: 'SET_NOTICE',
  SET_CHART_DATA: "SET_CHART_DATA",
  UPDATE_CHART_DATA: "UPDATE_CHART_DATA",
  UPDATE_FILTER_WARD: "UPDATE_FIL_WARD",
  SET_BANNER: "SET_BANNER",
  SET_FILTER_NOTICE_WARD: "SET_FILTER_NOTICE_WARD"
}